import React from 'react';
import { HeadingContainer } from '../styles';
const MainHeading = () => {
  return (
    <HeadingContainer>
      <h2 className='tt-title'>Build Your Own Box</h2>
      <p className='text-center'>Pick your favourite flavours to create the perfect box.</p>
    </HeadingContainer>
  );
};

export default MainHeading;
